import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    bankAccountDetailsLinkLabel: 'View IBAN',
    bankAccountStatementsLinkLabel: 'Export data',
    currentBalance: 'Account Balance',
    employeeTransactionsTitle: "{name}'s transactions",
    pending: 'Pending:',
    spentThisMonth: 'spent this month',
  },
  fr: {
    bankAccountDetailsLinkLabel: 'Voir l’IBAN',
    bankAccountStatementsLinkLabel: 'Exporter les données',
    currentBalance: 'Solde du compte',
    employeeTransactionsTitle: 'Transactions de {name}',
    pending: 'En attente :',
    spentThisMonth: 'dépensés ce mois-ci',
  },
} as const);

export default locales;
